import usePrivateApi from '../../../hooks/usePrivateApi'
import Button from '../../../components/Button'
import Dialog from '../../../components/Dialog'

const AdminCancelInviteModal = ({ isOpen, setIsOpen, membership }) => {
  const [{ isLoading, success, error }, { sendRequest }] = usePrivateApi()

  const handleSubmit = () => {
    sendRequest({
      url: `/admin/admins/invite/${membership.id}`,
      method: 'delete',
    })
  }

  if (error) {
    return (
      <Dialog
        isOpen={isOpen}
        setIsOpen={() => window.location.reload()}
        title="An error occurred"
        buttonProps={null}
      >
        <p className="mt-2 text-gray-600 text-sm">
          Could not cancel admin invite. Please try again later.
        </p>
        <Button
          className="mt-4"
          color="white"
          onClick={() => window.location.reload()}
        >
          Finish and close
        </Button>
      </Dialog>
    )
  }

  if (success) {
    return (
      <Dialog
        isOpen={isOpen}
        setIsOpen={() => window.location.reload()}
        title="Invitation cancelled"
        buttonProps={null}
      >
        <p className="mt-2 text-gray-600 text-sm">
          Successfully cancelled the invite for{' '}
          <strong>
            {membership.user.firstName} {membership.user.lastName}
          </strong>{' '}
          ({membership.user.email}).
        </p>
        <Button
          className="mt-4"
          color="white"
          onClick={() => window.location.reload()}
        >
          Finish and close
        </Button>
      </Dialog>
    )
  }

  return (
    <Dialog
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(false)}
      title="Cancel admin invitation"
      buttonProps={{
        children: isLoading ? 'Cancelling...' : 'Cancel invite',
        color: 'red',
        onClick: handleSubmit,
        disabled: isLoading,
      }}
    >
      <p className="mt-2 text-gray-600 text-sm">
        Are you sure you wish to cancel the invite for{' '}
        <strong>
          {membership.user.firstName} {membership.user.lastName}?
        </strong>
      </p>
      <p className="mt-2 text-gray-600 text-sm">
        This admin won't be able to login or carry out any actions in the system
        until they accept an invite. You can send another invite in the future
        if required.
      </p>
    </Dialog>
  )
}

export default AdminCancelInviteModal
